import { toUrlJSON } from './funcs';
import { Routes_DE } from './routes';

export const getPcpUrl = (
  isDefaultPriceRange: boolean,
  priceRange: {
    key: string;
    min: number;
    max: number;
  },
  make?: string,
  modelGroup?: string,
  model?: string,
  baseUrl?: URL
) => {
  const url = new URL(baseUrl || window.location.href.replace(/\?.*$/, '')); // strip parameters
  url.pathname = Routes_DE.CARS.ALL;

  if (!isDefaultPriceRange) {
    const v = toUrlJSON(priceRange);

    if (typeof v === 'string') {
      url.searchParams.set('priceRange', v);
    }
  }

  if (make || model) {
    const makeModel: Record<string, string> = {};

    if (make) {
      makeModel.makes = make;
    }

    if (model) {
      makeModel.models = model;
    }

    if (modelGroup) {
      makeModel.modelGroup = modelGroup;
    }

    const v = toUrlJSON([makeModel], false);

    if (typeof v === 'string') {
      url.searchParams.set('makeModel', v);
    }
  }

  return url;
};

export const getPcpUrlForAccessories = (
  brand?: string,
  model?: string,
  variant?: string
) => {
  const url = new URL(window.location.href.replace(/\?.*$/, '')); // strip parameters
  url.pathname = Routes_DE.PCP_ACCESSORIES;

  if (brand) {
    url.searchParams.set('brand', brand);
  }

  if (model) {
    url.searchParams.set('model', model);
  }

  if (variant) {
    url.searchParams.set('variant', variant);
  }

  return url;
};

export const getPcpUrlForContentPages = (
  priceRange: {
    key: string;
    min: number;
    max: number;
  },
  baseUrl: string,
  urlPath: string
) => {
  const url = new URL(baseUrl);
  const parsedParams = toUrlJSON(priceRange);
  if (typeof parsedParams === 'string') {
    url.searchParams.set('priceRange', parsedParams);
  }

  return `${urlPath}/${url.search}`;
};
